export const SupplierRoutes = {
  shopifyReauthStatus: '/api/shopify-reauth-status',
  shopifyReauthUrl: '/api/shopify-reauth-url',
  addCredit: '/api/add_credit',
  addAdjustment: 'api/add-adjustment',
  getProductImportProgress: 'api/get-product-import-progress',
  validateStoreUrl: 'api/validate-store-url',
  importProduct: 'api/import-product',
  getProductFromImportedFile: 'api/get-product-from-imported-file',
  loginAsAdmin: 'api/login-as-admin',
  roles: 'api/roles',
  updateUser: '/api/user',
  getLogs: 'api/get-logs',
  getOrdersExport: '/api/get-orders-export',
  getSumaiLineitemsExport: '/api/get-sumai-lineitems-export',
  orders: '/api/orders',
  payToSupplier: 'api/pay-to-supplier',
  exportPayout: '/api/export-payout',
  bulkPayToSupplier: 'api/bulk-pay-to-supplier',
  getPayoutBulkPay: '/api/get-payout-bulk-pay',
  getPayout: '/api/get-payout',
  getSuppliers: '/api/get-suppliers',
  getPayoutAnalytic: '/api/get-payout-analytic',
  requestCreditRedeem: '/api/request-credit-redeem',
  removePendingOrder: 'api/remove-pending-order',
  contactToStore: 'api/contact-to-store',
  contactToSupplier: 'api/contact-to-supplier',
  updateTracking: 'api/update-tracking',
  getPendingOrders: '/api/get-pending-orders',
  getSumaiOrders: '/api/get-sumai-orders',
  getProcessing: '/api/get-processing',
  addToImportList: 'api/add-to-import-list',
  removeFromImportList: 'api/remove-from-import-list',
  product: '/api/product',
  notifyUser: '/api/notifyUser',
  refundOrderItem: 'api/refund-order-item',
  syncShopifyProducts: 'api/sync_shopify_products',
  cancelOrder: '/api/cancel-order',
  getProduct: 'api/get-product',
  getShopifyProductList: 'api/getShopifyProductList',
  hideFromSumaiList: '/api/hide-from-sumai-list',
  getCity: 'api/get-city',
  getState: 'api/get-state',
  suppliers: 'api/suppliers',
  updateSupplier: '/api/update-supplier',
  addSupplier: '/api/add-supplier',
  deleteUser: 'api/deleteuser',
  updateOrderData: 'api/update-order-data',
  updateOrderTrackingNumber: 'api/update-order-tracking-number',
  removeCredit: 'api/remove_credit',
  loginAsUser: 'api/login-as-user',
  users: '/api/users',
  user: '/api/user',
  addUsers: '/api/addusers',
  updateSupplierNote: 'api/update-supplier-note',
  fetchGraphData: '/api/fetch-graph-data',
  fetchOverviewData: '/api/fetch-overview-data',
  fetchFulfillmentData: '/api/fetch-fulfillment-data',
  getProductInfo: '/api/get-product-info',
  updateProfileInfo: '/api/update-profile-info',
  setPassword: '/api/set-password',
  getCountries: 'api/get-countries',
  importOrderFile: 'api/import-order-file',
  exportOrderFile: '/api/export-order-file',
  getProductRelatedInfo: '/api/get-product-related-info',
  addProduct: '/api/add-product',
  exportProducts: '/api/export-products',
  bulkImportShopifyProducts: 'api/bulk-import-shopify-products',
  fetchShopifyProducts: '/api/fetch-shopify-products',
  getCategories: '/api/get-categories',
  addTrackingInfo: '/api/add-tracking-info',
  logout: '/api/auth/logout',
  oauth: '/api/oauth',
  importProductsPreview: '/api/imports/shopify/products/preview',
  importProductsSettings: '/api/imports/shopify/products',
  importProductsStatus: '/api/imports/shopify/products/status',
}
